import React, { useContext } from "react";
import { Formik } from "formik";
import EditOfferForm from "./EditOfferForm";
import { validateOffer } from "api/offersValidation";
import SaveBar from "components/SaveBar";
import { NavigationContext } from "contexts/Navigation";
import { hide as hideSaveBar } from "../../components/SaveBar";

export default function EditOfferFormWrapped(props) {
  const navigation = useContext(NavigationContext);
  const {
    appPlan,
    currency,
    dismissPPUInfoMessage,
    dismissPPUSettingsMessage,
    domain,
    flags,
    isNewOffer,
    offer,
    moneyFormat,
    multicurrencyWarningCard,
    onSubmit,
    ppuInfoMessageDismissed,
    ppuSettingsMessageDismissed,
    redirectToAppearance
  } = props;

  const handleDiscard = resetForm => {
    if (offer?.id) {
      resetForm();
    } else {
      // For new offers, hide save bar and navigate back to dashboard
      hideSaveBar();
      navigation.goTo("/");
    }
  };

  return (
    <Formik
      offerId={offer.id}
      onSubmit={onSubmit}
      initialValues={offer}
      validateOnBlur={false}
      validateOnChange={false}
      validate={values => {
        // eslint-disable-next-line no-unused-vars
        const [_, errors] = validateOffer(values);

        return errors;
      }}
    >
      {({ dirty, isSubmitting, resetForm, submitForm, ...form }) => (
        <>
          <SaveBar
            onDiscard={() => handleDiscard(resetForm)}
            onSave={submitForm}
            saveLoading={isSubmitting}
            visible={dirty}
          />
          <EditOfferForm
            appPlan={appPlan}
            currency={currency}
            dismissPPUInfoMessage={dismissPPUInfoMessage}
            dismissPPUSettingsMessage={dismissPPUSettingsMessage}
            domain={domain}
            flags={flags}
            form={{ dirty, isSubmitting, resetForm, submitForm, ...form }}
            isNewOffer={isNewOffer}
            moneyFormat={moneyFormat}
            multicurrencyWarningCard={multicurrencyWarningCard}
            offerId={offer.ID}
            ppuSettingsMessageDismissed={ppuSettingsMessageDismissed}
            ppuInfoMessageDismissed={ppuInfoMessageDismissed}
            redirectToAppearance={redirectToAppearance}
          />
        </>
      )}
    </Formik>
  );
}
